import { Component, Input, OnInit } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'dashboard-grid-boolean-filter',
    template: `
        <kendo-dropdownlist [data]="booleanSort" [textField]="'text'" [valueField]="'value'" [defaultItem]="{'text': 'All', 'value': -1}"
                            [valuePrimitive]="true" [(value)]="value" (selectionChange)="onChange($event)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
                <span *ngIf="dataItem !== undefined && dataItem['value'] === -1"> All</span>
                <span *ngIf="dataItem !== undefined && dataItem['value'] === false"
                      class="glyphicon glyphicon-remove"> {{dataItem['text']}}</span>
                <span *ngIf="dataItem !== undefined && dataItem['value'] === true"
                      class="glyphicon glyphicon-ok"> {{dataItem['text']}}</span>
            </ng-template>
        </kendo-dropdownlist>
    `,
    styles: [
        `.glyphicon-remove {
            color: #d9534f;
        }

        .glyphicon-ok  {
            color: #5cb85c;
        }
        `
    ]
})
export class DashboardBooleanFilterComponent extends BaseFilterCellComponent implements OnInit {
    @Input('filter') declare filter: CompositeFilterDescriptor; // Redeclare inherited 'filter' property for Angular input binding without redefining it.
    @Input('field') field!: string;

    value!: number;

    public booleanSort = [ //Boolean Sort DropDown Options
        { 'text': 'False', 'value': false },
        { 'text': 'True', 'value': true }
    ];

    constructor(filterService: FilterService) {
        super(filterService);
    }

    ngOnInit() {
        let filter = this.filterByField(this.field);
        if(filter) {
            this.value = filter.value;
        } else {
            this.value = -1;
        }
    }

    public onChange(value: any): void {
        this.value = value.value;
        this.applyFilter(
            this.value === -1 ? // if value of the default item
                this.removeFilter(this.field) : // remove the filter
                this.updateFilter({ // otherwise add/modify the filter for the field with the value
                    field: this.field,
                    operator: 'eq',
                    value: this.value
                })
        ); // and update the root filter
    }
}
